let storefrontLocale: string | undefined;

export function setStorefrontLocaleTag(localeTag: string): void {
  storefrontLocale = localeTag;
}

/** The locale tag stripped from this page's Shopify Markets URL, once. */
export function takeStorefrontLocaleTag(): string | undefined {
  const localeTag = storefrontLocale;
  storefrontLocale = undefined;
  return localeTag;
}
